(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fast-filters"] && !Shopify.designMode) return;
  try {
    
    class FastFiltersCarousel extends HTMLElement {
      connectedCallback() {
        this.slideshow = this.querySelector('slideshow-component');
        if (!this.slideshow) return;

        this.scroller =
          this.slideshow.refs?.scroller ||
          this.slideshow.querySelector('slideshow-slides');

        this.updateArrowVisibility = this.updateArrowVisibility.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.onSelect = this.onSelect.bind(this);

        // select fires before scroll animation finishes — re-check on scroll/scrollend
        this.slideshow.addEventListener('slideshow:select', this.onSelect);
        this.scroller?.addEventListener('scroll', this.onScroll, { passive: true });
        this.scroller?.addEventListener('scrollend', this.updateArrowVisibility);

        requestAnimationFrame(() => {
          this.updateArrowVisibility();
        });

        this.resizeObserver = new ResizeObserver(() => {
          this.updateArrowVisibility();
        });
        this.resizeObserver.observe(this.slideshow);
      }

      disconnectedCallback() {
        if (this.slideshow) {
          this.slideshow.removeEventListener('slideshow:select', this.onSelect);
        }
        if (this.scroller) {
          this.scroller.removeEventListener('scroll', this.onScroll);
          this.scroller.removeEventListener('scrollend', this.updateArrowVisibility);
        }
        clearTimeout(this.settleTimer);
        if (this.scrollRaf) cancelAnimationFrame(this.scrollRaf);
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }
      }

      onScroll() {
        if (this.scrollRaf) cancelAnimationFrame(this.scrollRaf);
        this.scrollRaf = requestAnimationFrame(() => {
          this.scrollRaf = null;
          this.updateArrowVisibility();
        });
      }

      onSelect() {
        // Fallback when scrollend unsupported / missed
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(this.updateArrowVisibility, 350);
      }

      updateArrowVisibility() {
        if (!this.slideshow || !this.scroller) return;

        // Scroll-based: no overflow → both ends true → both arrows hide
        const atStart = this.scroller.scrollLeft <= 1;
        const atEnd =
          this.scroller.scrollLeft + this.scroller.clientWidth >= this.scroller.scrollWidth - 1;

        this.slideshow.toggleAttribute('at-start', atStart);
        this.slideshow.toggleAttribute('at-end', atEnd);

        const prevButton = this.slideshow.querySelector('.slideshow-control--previous');
        const nextButton = this.slideshow.querySelector('.slideshow-control--next');

        if (prevButton) prevButton.disabled = atStart;
        if (nextButton) nextButton.disabled = atEnd;
      }
    }
  
    if (!customElements.get('fast-filters-carousel')) {
      customElements.define('fast-filters-carousel', FastFiltersCarousel);
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grs-clearance-demo"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-demo-currency]')) return;
    const section = event.target.closest('[data-clearance-demo-section]');
    const currency = event.target.value;
    section.querySelectorAll('grs-trade-clearance[data-demo]').forEach(element => {
      element.dataset.currency = currency;
      const script = element.querySelector('[data-clearance-variants]');
      script.textContent = JSON.stringify([{title:'All sample sizes',gbp:14.99,eur:22.70,demoPrice:currency === 'EUR' ? 7.80 : 6.00}]);
      element.connectedCallback();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
